import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-1d26236a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "item-actions"
}

import { ref } from 'vue'
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardTitle, IonIcon, modalController } from '@ionic/vue'
import { createOutline } from 'ionicons/icons'
import ContentBlocks from '@/components/ContentBlocks.vue'
import TextFormatter from '@/components/TextFormatter.vue'

import { useEventStore } from '@/store/event'
import type { EventPerformer } from '@/store/event'


export default /*#__PURE__*/_defineComponent({
  __name: 'PerformerCard',
  props: {
    item: {},
    opened: { type: Boolean }
  },
  setup(__props: any) {

const props = __props

const contentDiv = ref<HTMLDivElement>()
function observeContentSize ({ el }: any) {
  (new ResizeObserver(([{ target }]) => {
    if (contentDiv.value)
      contentDiv.value.style.setProperty('--offsetHeight', (target as HTMLElement).offsetHeight + 'px')
  })).observe(el)
}

const isAdmin = useEventStore().currentMember?.canWrite

async function editItem () {
  const PerformerForm = await import('@/components/PerformerForm.vue')
  return (await modalController.create({
    component: PerformerForm.default,
    componentProps: { origItem: props.item },
    ...PerformerForm.modalOptions
  })).present()
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonCard), {
    class: _normalizeClass({ opened: props.opened })
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(IonCardHeader), {
        style: _normalizeStyle({ '--photoUrl': `url(${_ctx.item.photoUrl})` }),
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('headerClicked')))
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(IonCardTitle), null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.item.name), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["style"]),
      _createElementVNode("div", {
        class: "content",
        ref_key: "contentDiv",
        ref: contentDiv
      }, [
        _createVNode(_unref(IonCardContent), { onVnodeMounted: observeContentSize }, {
          default: _withCtx(() => [
            (_unref(isAdmin))
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createVNode(_unref(IonButton), {
                    fill: "clear",
                    size: "small",
                    onClick: editItem
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_unref(IonIcon), {
                        slot: "icon-only",
                        icon: _unref(createOutline)
                      }, null, 8, ["icon"])
                    ]),
                    _: 1
                  })
                ]))
              : _createCommentVNode("", true),
            _createVNode(_unref(IonCardTitle), { class: "ion-padding-bottom" }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.item.name), 1)
              ]),
              _: 1
            }),
            _createVNode(TextFormatter, {
              value: _ctx.item.description
            }, null, 8, ["value"]),
            _createVNode(ContentBlocks, {
              value: _ctx.item.blocks
            }, null, 8, ["value"])
          ]),
          _: 1
        }, 512)
      ], 512)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})